import { ValueOf } from './util';

export const EGrantType = {
  RATE: '%',
  AMOUNT: '円またはpt',
} as const;

export type TGrantTypeKey = keyof typeof EGrantType;
export type TGrantTypeValue = ValueOf<typeof EGrantType>;

export const grantTypeKeys = Object.keys(EGrantType) as (TGrantTypeKey[]);

/** v-select用items */
export const grantTypeItems = grantTypeKeys
  .map((key) => ({
    title: EGrantType[key],
    value: key,
  }));
